import * as React from 'react';

export function EyeIcon({ size=20, stroke='#4e6e8e' }: { size?: number; stroke?: string }){
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 10C2 10 4.5 5 10 5C15.5 5 18 10 18 10C18 10 15.5 15 10 15C4.5 15 2 10 2 10Z" stroke={stroke} strokeWidth="2"/><circle cx="10" cy="10" r="3" stroke={stroke} strokeWidth="2"/></svg>
  );
}
export function EyeOffIcon({ size=20, stroke='#4e6e8e' }: { size?: number; stroke?: string }){
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 10C2 10 4.5 5 10 5C15.5 5 18 10 18 10C18 10 15.5 15 10 15C4.5 15 2 10 2 10Z" stroke={stroke} strokeWidth="2"/><path d="M6 6L14 14" stroke={stroke} strokeWidth="2"/></svg>
  );
}

export function ClearIcon({ size = 18, stroke = '#4e6e8e' }: { size?: number; stroke?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 6L14 14" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
      <path d="M14 6L6 14" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function EraserIcon({ size = 18, stroke = '#4e6e8e' }: { size?: number; stroke?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 4.5L16 8" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
      <path d="M3.5 13.5L12.5 4.5L16 8L8.5 15.5H5.5L3.5 13.5Z" stroke={stroke} strokeWidth="2" strokeLinejoin="round" />
      <path d="M8.5 15.5H16" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
